import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { MovieInfo, TVInfo } from '../Interface/Interface';
import { NavLink, useNavigate } from 'react-router-dom';

export default function Details() {
    const storageId = sessionStorage.getItem('movieID');
    const type = sessionStorage.getItem('movieType');


    const [movie, setMovie] = useState<MovieInfo>();
    const [tv, setTv] = useState<TVInfo>();
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    useEffect(() => {



        if (type != null && storageId != null) {
            if (type == 'movie') {
                getDetails(type, storageId, setMovie);

            }
            if (type == 'tv') {
                getDetails(type, storageId, setTv);

            }
            if (type == 'person') {


                navigate('/personDetailes')
            }
            setLoading(true)

        }



    }, [])

    async function getDetails(type: string, storageId: string, callBack: any) {

        const { data } = await axios.get(`https://api.themoviedb.org/3/${type}/${storageId}?api_key=52554469fe208e948caaf074d2683e95&language=en-US`);
        callBack(data)
        setLoading(false)

    }


    return (<>


        {type === 'movie' ? loading ? <div className='loaddrComtainer '>
            <span className="loader"></span>
        </div> : <>
            <div className="row py-4">
                <div className="col-md-4 " >
                    <img src={`https://image.tmdb.org/t/p/w500/` + movie?.poster_path} className='w-100' alt={movie?.title} />

                </div>
                <div className="col-md-8">
                    <h2 >{movie?.title}</h2>
                    <div className='px-3 py-3   '>
                        {movie?.genres.map((el) => <p className='p-1 bg-info d-inline-block me-2 rounded-2 ' key={el.id}>{el.name}</p>)}

                        <ul className='list-unstyled py-2'>
                            <li className='py-2'> Vote :  {movie?.vote_average}</li>
                            <li className='py-2'> Vote count :  {movie?.vote_count}</li>
                            <li className='py-2'> Popularity :  {movie?.popularity}</li>
                            {movie?.budget == 0 ? '' : <li className='py-2'> Budget :  {movie?.budget} $</li>}


                            < > Release date: {movie?.release_date}</>
                        </ul>
                        <p className='py-3 text-muted fs-4'> {movie?.overview}</p>
                        <a href={movie?.homepage} target="_blank"  > <button className='btn  btn-outline-primary '> watch movie <i className="fa-solid fa-film px-1"></i> </button></a>
                        <NavLink to={'/movies'}> <button className='btn btn-outline-success mx-2'> watch more movies</button> </NavLink>

                    </div>
                </div>
            </div>  </> :
            loading ? <div className='loaddrComtainer '>
                <span className="loader"></span>
            </div> : <>
                <>
                    <div className="row py-4">
                        <div className="col-md-4 ">
                            <img src={`https://image.tmdb.org/t/p/w500/` + tv?.poster_path} className='w-100' alt={tv?.name} />

                        </div>
                        <div className="col-md-8">
                            <h2 >{tv?.name}</h2>
                            <div className='px-3 py-3   '>
                                {tv?.genres.map((el) => <p className='p-1 bg-info d-inline-block me-2 rounded-2 ' key={el.id}>{el.name}</p>)}

                                <ul className='list-unstyled py-2'>
                                    <li className='py-2'> Vote :  {tv?.vote_average}</li>
                                    <li className='py-2'> Vote count :  {tv?.vote_count}</li>
                                    <li className='py-2'> Popularity :  {tv?.popularity}</li>

                                    <li className='py-2'> number of seasons :  {tv?.number_of_seasons}</li>
                                    {tv?.number_of_episodes ? <li className='py-2'> number of episodes :  {tv?.number_of_episodes}</li> : ''}
                                    <li className='py-2'> number of episodes :  {tv?.number_of_episodes}</li>
                                    < > Release date: {tv?.first_air_date}</>
                                    {tv?.last_air_date ? <div className=' py-2'>  < > Release date: {tv?.last_air_date}</></div> : ''}



                                </ul>
                                <p className='py-3 text-muted fs-4'> {tv?.overview}</p>
                                {tv?.homepage ? <a href={tv?.homepage} target="_blank"  > <button className='btn btn-outline-primary  '> watch tv show <i className="fa-solid fa-film px-1"></i> </button></a> : ''}

                                <NavLink to={'/tv'}> <button className='btn btn-outline-success mx-2'> watch more Tv Shows</button> </NavLink>
                            </div>
                        </div>
                    </div>  </>

            </>

        }


    </>


    )
}
